/**
 * Vertex batch contract. custom is Detectron2 JSONL. automl is Vertex AutoML JSONL.
 * Forecast currently starts Detectron2 only. The type stays so a later catalog
 * can send either contract without a new request shape.
 */
export enum AutomatedDefectDetectionModelType {
  Custom = 'custom',
  AutoML = 'automl',
}

export const isAutomatedDefectDetectionModelType = (
  value: string | undefined
): value is AutomatedDefectDetectionModelType =>
  value === AutomatedDefectDetectionModelType.Custom ||
  value === AutomatedDefectDetectionModelType.AutoML
